<template>
  <div class="form-group custom-form-group">
    <label v-if="label" class="custom-form-group-label">
      {{ label }}
    </label>
    <span v-if="disclaimer" class="custom-form-group-disclaimer">
      {{ disclaimer }}
    </span>
    <div class="ihjoz-toggle">
      <input type="hidden" :name="name" :value="falseValue">
      <input :id="id"
             type="checkbox"
             :name="name"
             :checked="checkedValue"
             :value="trueValue"
             :disabled="disabled"
             class="ihjoz-toggle-input"
             @change="$emit('input', emittedValue($event.target.checked))">
      <label class="ihjoz-toggle-button" :for="id">
        <i class="demo-icon" :class="falseIcon" />
        <i class="demo-icon" :class="trueIcon" />
        <span class="ihjoz-toggle-button-slider" />
      </label>
    </div>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";

export default {
  name: "ToggleButton",

  mixins: [
    UIComponentMixin
  ],

  props: {
    name: { type: String },
    label: { type: String },
    disclaimer: { type: String },
    defaultChecked: { type: Boolean, required: true },
    invertValue: { type: Boolean, default: false },
    checked: { type: Boolean, default: null },
    value: { type: [Boolean, String], default: null },
    falseValue: { type: [Boolean, String, Number], default: false },
    trueValue: { type: [Boolean, String, Number], default: true },
    trueIcon: { type: String, default: "icon-check" },
    falseIcon: { type: String, default: "icon-times" },
    disabled: { type: Boolean, default: false }
  },

  computed: {
    checkedValue () {
      if (this.checked !== null) {
        return this.checked;
      } else if (this.value !== null) {
        return this.value;
      } else {
        return this.defaultChecked;
      }
    }
  },

  methods: {
    emittedValue (checked) {
      if (checked) {
        return this.trueValue;
      } else {
        return this.falseValue;
      }
    }
  }
};
</script>
